export default function() {}



//////////////////
// WEBPACK FOOTER
// ../~/d3-shape/src/noop.js
// module id = Hgxp
// module chunks = 0